var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 11.9999C22.0002 17.3018 17.7021 21.5999 12.4002 21.5999C7.09824 21.5999 2.80017 17.3018 2.80017 11.9999C2.80017 6.69797 7.09824 2.3999 12.4002 2.3999C17.7021 2.3999 22.0002 6.69797 22.0002 11.9999ZM8.55164 8.15141C9.02027 7.68278 9.78007 7.68278 10.2487 8.15141L12.4002 10.3029L14.5516 8.15137C15.0203 7.68275 15.7801 7.68275 16.2487 8.15137C16.7173 8.62 16.7173 9.3798 16.2487 9.84843L14.0972 11.9999L16.2487 14.1514C16.7173 14.62 16.7173 15.3798 16.2487 15.8485C15.7801 16.3171 15.0203 16.3171 14.5516 15.8485L12.4002 13.697L10.2487 15.8484C9.78007 16.3171 9.02027 16.3171 8.55164 15.8484C8.08301 15.3798 8.08301 14.62 8.55164 14.1514L10.7031 11.9999L8.55164 9.84847C8.08301 9.37984 8.08301 8.62004 8.55164 8.15141Z",
    fill: "#56E099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleGreen);
export default __webpack_public_path__ + "static/media/close-circle-green.9bcfb3ee98b077c9cc0130962fcce65a.svg";
export { ForwardRef as ReactComponent };